module.exports = __webpack_public_path__ + "img/logo.8878de79.png";